(ns frontend.ux-overhaul.listing.screening.event
  (:require
   [common.localization :as loc]
   [frontend.conn :as conn]
   [frontend.logging :as logging]
   [frontend.ux-overhaul.listing.generic.event :as generic-event]
   [frontend.ux-overhaul.listing.generic.model :as generic-model]
   [frontend.ux-overhaul.listing.generic.selection :as selection-helpers]
   [frontend.ux-overhaul.listing.screening.model :as model]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]
   [promesa.core :as p]
   [re-frame.core :as rf]
   [ui.completion.event :as completion-event]
   [ui.view.grid-opensearch.event :as grid-event]))

(rf/reg-event-db
 ::open-bulk-edit
 (fn [db _]
   (assoc-in db model/bulk-edit-open?-full-path true)))

(rf/reg-event-fx
 ::close-bulk-edit
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   {:db (assoc-in db model/bulk-edit-open?-full-path false)
    :fx [[:dispatch [::grid-event/trigger-query-search
                     (str listing-id "-grid")]]]}))

(rf/reg-event-fx
 ::bulk-delete-selected
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   (let [selection (get-in db (generic-model/selection-path listing-id))
         selected-ids (selection-helpers/action-ids selection)]
     (if (seq selected-ids)
       (do
         (modals/open-modal!
          confirmation/modal-key
          {:body          (selection-helpers/delete-confirmation-body selection)
           :confirm-text  (loc/tr :confirm-delete-selected-button)
           :checkbox-text (loc/tr :confirm-delete-selected-checkbox)
           :on-confirm    (fn []
                            (-> (conn/sendp! :screening-profile/mass-action
                                             {:action :delete-screening-profiles
                                              :screening-profile-ids selected-ids})
                                (p/then (fn [resp]
                                          (rf/dispatch [::generic-event/clear-selection listing-id])
                                          ;; Wait for the delete's off-thread
                                          ;; search reindex before refetching -
                                          ;; see ui.completion.event.
                                          (rf/dispatch
                                           [::completion-event/await
                                            {:completion-id (:completion/id resp)
                                             :on-complete   [::grid-event/trigger-query-search
                                                             (str listing-id "-grid")]}])))
                                (p/catch (fn [err]
                                           (logging/error "Unable to delete selected screening-profiles" err)))))})
         {})
       {}))))
